//首页地图部分5个地图
var geoCoordMap = {};
// var nameMap = {
//   'Afghanistan': '阿富汗',
//   'Albania': '阿尔巴尼亚',
//   'Algeria': '阿尔及利亚',
//   'Andorra': '安道尔',
//   'Angola': '安哥拉',
//   'Antarctica': '南极洲',
//   'Antigua and Barbuda': '安提瓜和巴布达',
//   'Argentina': '阿根廷',
//   'Armenia': '亚美尼亚',
//   'Australia': '澳大利亚',
//   'Austria': '奥地利',
//   'Azerbaijan': '阿塞拜疆',
//   'The Bahamas': '巴哈马',
//   'Bahrain': '巴林',
//   'Bangladesh': '孟加拉国',
//   'Barbados': '巴巴多斯',
//   'Belarus': '白俄罗斯',
//   'Belgium': '比利时',
//   'Belize': '伯利兹',
//   'Benin': '贝宁',
//   'Bermuda': '百慕大',
//   'Bhutan': '不丹',
//   'Bolivia': '玻利维亚',
//   'Bosnia and Herzegovina': '波斯尼亚和黑塞哥维那',
//   'Botswana': '博茨瓦纳',
//   'Brazil': '巴西',
//   'Brunei': '文莱',
//   'Bulgaria': '保加利亚',
//   'Burkina Faso': '布基纳法索',
//   'Burundi': '布隆迪',
//   'Cambodia': '柬埔寨',
//   'Cameroon': '喀麦隆',
//   'Canada': '加拿大',
//   'Cape Verde': '佛得角',
//   'Central African Republic': '中非共和国',
//   'Chad': '乍得',
//   'Chile': '智利',
//   'China': '中国',
//   'Colombia': '哥伦比亚',
//   'Comoros': '科摩罗',
//   'Republic of the Congo': '刚果共和国',
//   'Costa Rica': '哥斯达黎加',
//   'Croatia': '克罗地亚',
//   'Cuba': '古巴',
//   'Cyprus': '塞浦路斯',
//   'Czech Republic': '捷克共和国',
//   'Denmark': '丹麦',
//   'Djibouti': '吉布提',
//   'Dominica': '多米尼加',
//   'Dominican Republic': '多明尼加共和国',
//   'Ecuador': '厄瓜多尔',
//   'Egypt': '埃及',
//   'El Salvador': '萨尔瓦多',
//   'Equatorial Guinea': '赤道几内亚',
//   'Eritrea': '厄立特里亚',
//   'Estonia': '爱沙尼亚',
//   'Ethiopia': '埃塞俄比亚',
//   'Falkland Islands': '福克兰群岛',
//   'Faroe Islands': '法罗群岛',
//   'Fiji': '斐济',
//   'Finland': '芬兰',
//   'France': '法国',
//   'French Guiana': '法属圭亚那',
//   'French Southern and Antarctic Lands': '法属南半球和南极领地',
//   'Gabon': '加蓬',
//   'Gambia': '冈比亚',
//   'Gaza Strip': '加沙',
//   'Georgia': '格鲁吉亚',
//   'Germany': '德国',
//   'Ghana': '加纳',
//   'Greece': '希腊',
//   'Greenland': '格陵兰',
//   'Grenada': '格林纳达',
//   'Guadeloupe': '瓜德罗普',
//   'Guatemala': '危地马拉',
//   'Guinea': '几内亚',
//   'Guinea Bissau': '几内亚比绍',
//   'Guyana': '圭亚那',
//   'Haiti': '海地',
//   'Honduras': '洪都拉斯',
//   'Hong Kong': '香港',
//   'Hungary': '匈牙利',
//   'Iceland': '冰岛',
//   'India': '印度',
//   'Indonesia': '印尼',
//   'Iran': '伊朗',
//   'Iraq': '伊拉克',
//   'Iraq-Saudi Arabia Neutral Zone': '伊拉克阿拉伯中立区',
//   'Ireland': '爱尔兰',
//   'Isle of Man': '马恩岛',
//   'Israel': '以色列',
//   'Italy': '意大利',
//   'Ivory Coast': '科特迪瓦',
//   'Jamaica': '牙买加',
//   'Jan Mayen': '扬马延岛',
//   'Japan': '日本',
//   'Jordan': '约旦',
//   'Kazakhstan': '哈萨克斯坦',
//   'Kenya': '肯尼亚',
//   'Kerguelen': '凯尔盖朗群岛',
//   'Kiribati': '基里巴斯',
//   'North Korea': '北朝鲜',
//   'South Korea': '韩国',
//   'Kuwait': '科威特',
//   'Kyrgyzstan': '吉尔吉斯斯坦',
//   'Laos': '老挝',
//   'Latvia': '拉脱维亚',
//   'Lebanon': '黎巴嫩',
//   'Lesotho': '莱索托',
//   'Liberia': '利比里亚',
//   'Libya': '利比亚',
//   'Liechtenstein': '列支敦士登',
//   'Lithuania': '立陶宛',
//   'Luxembourg': '卢森堡',
//   'Macau': '澳门',
//   'Macedonia': '马其顿',
//   'Madagascar': '马达加斯加',
//   'Malawi': '马拉维',
//   'Malaysia': '马来西亚',
//   'Maldives': '马尔代夫',
//   'Mali': '马里',
//   'Malta': '马耳他',
//   'Martinique': '马提尼克',
//   'Mauritania': '毛里塔尼亚',
//   'Mauritius': '毛里求斯',
//   'Mexico': '墨西哥',
//   'Moldova': '摩尔多瓦',
//   'Monaco': '摩纳哥',
//   'Mongolia': '蒙古',
//   'Morocco': '摩洛哥',
//   'Mozambique': '莫桑比克',
//   'Myanmar': '缅甸',
//   'Namibia': '纳米比亚',
//   'Nepal': '尼泊尔',
//   'Netherlands': '荷兰',
//   'New Caledonia': '新喀里多尼亚',
//   'New Zealand': '新西兰',
//   'Nicaragua': '尼加拉瓜',
//   'Niger': '尼日尔',
//   'Nigeria': '尼日利亚',
//   'Northern Mariana Islands': '北马里亚纳群岛',
//   'Norway': '挪威',
//   'Oman': '阿曼',
//   'Pakistan': '巴基斯坦',
//   'Panama': '巴拿马',
//   'Papua New Guinea': '巴布亚新几内亚',
//   'Paraguay': '巴拉圭',
//   'Peru': '秘鲁',
//   'Philippines': '菲律宾',
//   'Poland': '波兰',
//   'Portugal': '葡萄牙',
//   'Puerto Rico': '波多黎各',
//   'Qatar': '卡塔尔',
//   'Reunion': '留尼旺岛',
//   'Romania': '罗马尼亚',
//   'Russia': '俄罗斯',
//   'Rwanda': '卢旺达',
//   'San Marino': '圣马力诺',
//   'Sao Tome and Principe': '圣多美和普林西比',
//   'Saudi Arabia': '沙特阿拉伯',
//   'Senegal': '塞内加尔',
//   'Seychelles': '塞舌尔',
//   'Sierra Leone': '塞拉利昂',
//   'Singapore': '新加坡',
//   'Slovakia': '斯洛伐克',
//   'Slovenia': '斯洛文尼亚',
//   'Solomon Islands': '所罗门群岛',
//   'Somalia': '索马里',
//   'South Africa': '南非',
//   'Spain': '西班牙',
//   'Sri Lanka': '斯里兰卡',
//   'St. Christopher-Nevis': '圣',
//   'St. Lucia': '圣露西亚',
//   'St. Vincent and the Grenadines': '圣文森特和格林纳丁斯',
//   'Sudan': '苏丹',
//   'Suriname': '苏里南',
//   'Svalbard': '斯瓦尔巴特群岛',
//   'Swaziland': '斯威士兰',
//   'Sweden': '瑞典',
//   'Switzerland': '瑞士',
//   'Syria': '叙利亚',
//   'Taiwan': '台湾',
//   'Tajikistan': '塔吉克斯坦',
//   'United Republic of Tanzania': '坦桑尼亚',
//   'Thailand': '泰国',
//   'Togo': '多哥',
//   'Tonga': '汤加',
//   'Trinidad and Tobago': '特里尼达和多巴哥',
//   'Tunisia': '突尼斯',
//   'Turkey': '土耳其',
//   'Turkmenistan': '土库曼斯坦',
//   'Turks and Caicos Islands': '特克斯和凯科斯群岛',
//   'Uganda': '乌干达',
//   'Ukraine': '乌克兰',
//   'United Arab Emirates': '阿联酋',
//   'United Kingdom': '英国',
//   'United States': '美国',
//   'Uruguay': '乌拉圭',
//   'Uzbekistan': '乌兹别克斯坦',
//   'Vanuatu': '瓦努阿图',
//   'Venezuela': '委内瑞拉',
//   'Vietnam': '越南',
//   'Western Sahara': '西撒哈拉',
//   'Western Samoa': '西萨摩亚',
//   'Yemen': '也门',
//   'Yugoslavia': '南斯拉夫',
//   'Democratic Republic of the Congo': '刚果民主共和国',
//   'Zambia': '赞比亚',
//   'Zimbabwe': '津巴布韦',   
//   'South Sudan': '南苏丹',
//   'Somaliland': '索马里兰',
//   'Montenegro': '黑山',
//   'Kosovo': '科索沃',
//   'Republic of Serbia': '塞尔维亚',
// };
// CGIT
export function initCGITmap(CGITmap, worlddata, geoCoordMapdata) {
  geoCoordMap = geoCoordMapdata;

  CGITmap.clear();

  //初始化数据
  var json = worlddata;
  var seriesJson = [];
  var tCityJsonData = [];
  var timearray = [];

  //将json转成数组
  if (json != null && json.length > 0) {
    for (var i = 0; i < json.length; i++) { //年度
      var year = json[i].year;
      timearray.push(year);
      var content = "";
      var arrContent = [];
      var arrtoCity = [];
      if (json != null && json.length > 0) { //每年数量
        for (var j = 0; j < json[i].data.length; j++) {
          var fcity = json[i].data[j][0].name;
          var tcity = json[i].data[j][1].name;
          var value = json[i].data[j][1].value;
          var count = json[i].data[j][1].count;
          var worldPieces = json[i].pieces; //图例
          content = [{
            name: fcity
          }, {
            name: tcity,
            value: value,
            year: year,
            count: count,
            worldPieces: worldPieces //图例
          }];
          arrContent.push(content);
          let fromCoord = geoCoordMap[fcity];
          let toCoord = geoCoordMap[tcity];

          if (toCoord != undefined)
            arrtoCity.push({
              //  name: tcity,
              value: [toCoord[0], toCoord[1], 30, value]
            }, {
              //  name: fcity,
              value: [fromCoord[0], fromCoord[1], 30, value]
            })
        }
      }

      seriesJson[i] = new Array();
      tCityJsonData[i] = new Array();
      tCityJsonData[i].push(arrtoCity);
      seriesJson[i].push(arrContent);
    }
  }

  var planePath = 'arrow'; //箭头的svg

  //获取地图中起点和终点的坐标，以数组形式保存下来
  var convertData = function (data) {
    var res = [];
    for (var i = 0; i < data.length; i++) {
      var fromCoord = geoCoordMap[data[i][0].name];
      var toCoord = geoCoordMap[data[i][1].name];
      if (fromCoord && toCoord) {
        res.push({
          fromName: data[i][0].name,
          toName: data[i][1].name,
          value: data[i][1].value,
          year: data[i][1].year,
          count: data[i][1].count,
          coords: [fromCoord, toCoord],
          worldPieces: data[i][1].worldPieces //图例
        })
      }
    }
    return res;
  }

  var color = ['#FFAE00', '#FF406D', '#06EAD7', '#09ABFF'];
  var series = []; // 用来存储地图数据

  seriesJson.forEach(function (item, i) {
    var itemarray = item[0];

    //设置图例颜色//图例
    if (itemarray[0][1].worldPieces.length == 1) //只有一个图例时设置一个颜色
      color = ['#FFAE00'];
    else //4个图例时设置4个颜色
      color = ['#FFAE00', '#FF406D', '#06EAD7', '#09ABFF'];

    series[i] = new Array();
    series[i].push({
      type: 'lines',
      zlevel: 2,
      effect: {
        show: true,
        period: 6,
        trailLength: 0,
        symbol: planePath,
        symbolSize: 7
      },
      lineStyle: {
        normal: {
          color: [],
          width: 2,
          opacity: 0.7,
          curveness: -0.1 //幅度
        }
      },
      data: convertData(itemarray)
    }, {
      type: 'effectScatter',
      coordinateSystem: 'geo',
      zlevel: 3,
      rippleEffect: {
        brushType: 'stroke'
      },
      label: {
        normal: {
          show: true,
          position: 'left',
          formatter: '{b}'
        }
      },
      symbolSize: 3,
      data: tCityJsonData[i][0]
    });
  });

  var arrOptions = [];
  for (var i = 0; i < json.length; i++) {
    arrOptions[i] = new Array();
    var op = {
      title: {
        // text: '美国企业研究所',
        right: '10',
        bottom: '50',
        textStyle: {
          color: '#fff',
          fontSize: 14,
          fontWeight: 'normal',
        }
      },
      tooltip: {
        trigger: 'item',
        background: 'rgba(7,39,104,.6)',
        'confine': true,
        'formatter': function (p) {
          var dataCon = p.data;
          if (dataCon.year != undefined)
            return dataCon.year + "年<br/>" + dataCon.fromName + '->' + dataCon.toName + '<br/>金额:' + dataCon.value + '(亿美元)<br/>项目个数:' + dataCon.count;
        },
      },
      geo: {
        map: 'world',
        label: { // 鼠标移到各个地区显示地区名称
          emphasis: {
            show: true
          }
        },
        // center: [108.67, 23.68],
        top: 20, //地图距上距离 
        aspectScale: 0.75,
        roam: false, // 是否开启鼠标缩放和平移漫游。默认不开启。如果只想要开启缩放或者平移，可以设置成 'scale' 或者 'move'。设置成 true 为都开启
        // scaleLimit: { //滚轮缩放的极限控制
        //   min: 1,
        //   max: 2
        // },
        zoom: 1.06,
        itemStyle: {
          normal: {
            areaColor: '#17468f',
            borderColor: '#04184b'
          },
          emphasis: {
            areaColor: '#259ef9'
          }
        },
        regions: [{}]
      },
      series: series[i], // 将之前处理的数据放到这里
      textStyle: {
        fontSize: 12
      },
      visualMap: {
        type: 'piecewise',
        pieces: json[i].pieces, //每次改变visualmap//图例
        hoverLink: true, //鼠标悬浮到 visualMap 组件上时，鼠标位置对应的数值 在 图表中对应的图形元素，会高亮
        left: "left", //组件离容器左侧的距离,'left', 'center', 'right','20%'
        top: "45%", //组件离容器上侧的距离,'top', 'middle', 'bottom','20%'
        right: "20%", //组件离容器右侧的距离,'20%'
        bottom: "30%", //组件离容器下侧的距离,'20%'
        orient: "vertical", //图例排列方向
        padding: [50, 10, 80, 60], //图例内边距，单位px  5  [5, 10]  [5,10,5,10]
        realtime: false,
        calculable: false,
        inRange: { //定义 在选中范围中 的视觉元素
          color: color //图例
        },
        textStyle: { //字体颜色
          color: "#fff"
        },
        show: true
      },
    };
    arrOptions[i] = op;
  }

  //最后初始化世界地图中的相关数据
  var option = {
    timeline: {
      axisType: 'category',
      data: timearray,
      autoPlay: true,
      playInterval: 5000,
      left: '2%',
      right: '2%',
      label: {
        normal: {
          textStyle: {
            color: '#fff' //年份字体颜色
          }
        },
        emphasis: {
          textStyle: {
            color: '#000'
          }
        }
      },
      lineStyle: {
        color: '#195ABE' //时间轴颜色
      },
      controlStyle: { //暂停”按钮
        normal: {
          color: '#fff',
          borderColor: '#fff'
        },
        emphasis: {
          color: '#fff',
          borderColor: '#fff'
        }
      },
    },
    baseOption: {},
    options: arrOptions
  };

  CGITmap.setOption(option);
}
// Trade
export function initTrademap(Trademap, worlddata, geoCoordMapdata) {
  geoCoordMap = geoCoordMapdata;
  Trademap.clear();

  //初始化数据
  var json = worlddata;
  var seriesJson = [];
  var tCityJsonData = [];
  var timearray = [];

  //将json转成数组
  if (json != null && json.length > 0) {
    for (var i = 0; i < json.length; i++) { //年度
      var year = json[i].year;
      timearray.push(year);
      var content = "";
      var arrContent = [];
      var arrtoCity = [];
      if (json != null && json.length > 0) { //每年数量
        for (var j = 0; j < json[i].data.length; j++) {
          // var fcity = json[i].data[j][0].name;
          var fcity = "中国";
          var tcity = json[i].data[j][1].name;
          var value = json[i].data[j][1].value;
          var worldTradePieces = json[i].pieces; //图例
          content = [{
            name: fcity
          }, {
            name: tcity,
            value: value,
            year: year,
            worldTradePieces: worldTradePieces //图例
          }];
          arrContent.push(content);
          let fromCoord = geoCoordMap[fcity];
          let toCoord = geoCoordMap[tcity];
          if (toCoord != undefined)
            arrtoCity.push({
              // name: tcity,
              value: [toCoord[0], toCoord[1], 30, value]
            }, {
              // name: fcity,
              value: [fromCoord[0], fromCoord[1], 30, value]
            })
        }
      }

      seriesJson[i] = new Array();
      tCityJsonData[i] = new Array();
      tCityJsonData[i].push(arrtoCity);
      seriesJson[i].push(arrContent);
    }
  }

  var planePath = 'arrow'; //箭头的svg

  //获取地图中起点和终点的坐标，以数组形式保存下来
  var convertData = function (data) {
    var res = [];
    for (var i = 0; i < data.length; i++) {
      var fromCoord = geoCoordMap[data[i][0].name];
      var toCoord = geoCoordMap[data[i][1].name];
      if (fromCoord && toCoord) {
        res.push({
          fromName: data[i][0].name,
          toName: data[i][1].name,
          value: data[i][1].value,
          year: data[i][1].year,
          coords: [fromCoord, toCoord],
          worldTradePieces: data[i][1].worldTradePieces //图例
        })
      }
    }
    return res;
  }

  var color = ['#FFAE00', '#FF406D', '#06EAD7', '#09ABFF'];
  var series = []; // 用来存储地图数据
  seriesJson.forEach(function (item, i) {
    var itemarray = item[0];

    //设置图例颜色//图例
    if (itemarray[0][1].worldTradePieces.length == 1) //只有一个图例时设置一个颜色
      color = ['#FFAE00'];
    else //4个图例时设置4个颜色
      color = ['#FFAE00', '#FF406D', '#06EAD7', '#09ABFF'];

    series[i] = new Array();
    series[i].push({
      type: 'lines',
      zlevel: 2,
      effect: {
        show: true,
        period: 6,
        trailLength: 0,
        symbol: planePath,
        symbolSize: 7
      },
      lineStyle: {
        normal: {
          color: [],
          width: 2,
          opacity: 0.7,
          curveness: -0.1 //幅度
        }
      },
      data: convertData(itemarray)
    }, {
      type: 'effectScatter',
      coordinateSystem: 'geo',
      zlevel: 3,
      rippleEffect: {
        brushType: 'stroke'
      },
      label: {
        normal: {
          show: true,
          position: 'left',
          formatter: '{b}'
        }
      },
      symbolSize: 3,
      data: tCityJsonData[i][0]
    });
  });

  var arrOptions = [];
  for (var i = 0; i < json.length; i++) {
    arrOptions[i] = new Array();

    var op = {
      title: {
        // text: '图中数据是由海关统计数据在线查询平台（http://43.248.49.97）公布数据汇总得出',
        right: '0',
        bottom: '50',
        textStyle: {
          color: '#fff',
          fontSize: 14,
          fontWeight: 'normal',
        }
      },
      tooltip: {
        trigger: 'item',
        background: 'rgba(7,39,104,.6)',
        'confine': true,
        'formatter': function (p) {
          var dataCon = p.data;
          // 对数字进行千分分隔符处理
          var valueTrade = ''
          var valueString = dataCon.value.toString()
          var valueStringLength = valueString.slice(0, valueString.lastIndexOf('.')).length
          if (valueStringLength > 3 && valueStringLength < 7) {
            valueTrade = valueString.slice(0, (valueString.lastIndexOf('.') - 3)) + ',' + valueString.slice(valueString.lastIndexOf('.') - 3)
          } else if (valueStringLength <= 3) {
            valueTrade = valueString
          } else {
            valueTrade = valueString
          }
          // console.log(valueString,'valueString')
          // console.log(valueStringLength,'valueStringLength')
          // console.log(valueTrade,'valueTrade')
          if (dataCon.year != undefined)
            return dataCon.year + "年<br/>" + dataCon.fromName + '->' + dataCon.toName + '<br/>金额:' + valueTrade + '(百万美元)';
        },
      },
      geo: {
        map: 'world',
        top: 20,
        label: { // 鼠标移到各个地区显示地区名称
          emphasis: {
            show: true
          }
        },
        aspectScale: 0.75,
        roam: false, // 是否开启鼠标缩放和平移漫游。默认不开启。如果只想要开启缩放或者平移，可以设置成 'scale' 或者 'move'。设置成 true 为都开启
        // scaleLimit: { //滚轮缩放的极限控制
        //   min: 1,
        //   max: 2
        // },
        zoom: 1.06,
        itemStyle: {
          normal: {
            areaColor: '#17468f',
            borderColor: '#04184b'
          },
          emphasis: {
            areaColor: '#ffcc5f'
          }
        },
        regions: [{}]
      },
      series: series[i], // 将之前处理的数据放到这里
      textStyle: {
        fontSize: 12
      },
      visualMap: {
        type: 'piecewise',
        pieces: json[i].pieces, //每次改变visualmap //图例
        hoverLink: true, //鼠标悬浮到 visualMap 组件上时，鼠标位置对应的数值 在 图表中对应的图形元素，会高亮
        left: "left", //组件离容器左侧的距离,'left', 'center', 'right','20%'
        top: "45%", //组件离容器上侧的距离,'top', 'middle', 'bottom','20%'
        right: "20%", //组件离容器右侧的距离,'20%'
        bottom: "30%", //组件离容器下侧的距离,'20%' 
        orient: "vertical", //图例排列方向
        padding: [50, 10, 80, 60], //图例内边距，单位px  5  [5, 10]  [5,10,5,10]
        realtime: false,
        calculable: false,
        inRange: { //定义 在选中范围中 的视觉元素
          color: color //图例
        },
        textStyle: { //字体颜色
          color: "#fff"
        },
        show: true
      },

    };

    arrOptions[i] = op;
  }

  //最后初始化世界地图中的相关数据
  var option = {
    timeline: {
      axisType: 'category',
      data: timearray,
      autoPlay: true,
      playInterval: 5000,
      left: '2%',
      right: '2%',
      label: {
        normal: {
          textStyle: {
            color: '#fff' //年份字体颜色
          }
        },
        emphasis: {
          textStyle: {
            color: '#000'
          }
        }
      },
      lineStyle: {
        color: '#195ABE' //时间轴颜色
      },
      controlStyle: { //暂停”按钮
        normal: {
          color: '#fff',
          borderColor: '#fff'
        },
        emphasis: {
          color: '#fff',
          borderColor: '#fff'
        }
      },
    },
    baseOption: {
      // visualMap: {
      //   type: 'piecewise',
      //   //0-100w,-1亿，-10亿，max
      //   pieces: [{
      //       min: 1000000001,
      //       max: 10000000000000,
      //       label: '1000000001以上'
      //     }, {
      //       min: 100000001,
      //       max: 1000000000,
      //       label: '100000001-1000000000'
      //     },

      //     {
      //       min: 1000001,
      //       max: 100000000,
      //       label: '1000001-100000000'
      //     },
      //     {
      //       max: 0,
      //       max: 1000000,
      //       label: '0-1000000'
      //     }
      //   ],
      //   hoverLink: true, //鼠标悬浮到 visualMap 组件上时，鼠标位置对应的数值 在 图表中对应的图形元素，会高亮
      //   left: "left", //组件离容器左侧的距离,'left', 'center', 'right','20%'
      //   top: "50%", //组件离容器上侧的距离,'top', 'middle', 'bottom','20%'
      //   right: "20%", //组件离容器右侧的距离,'20%'
      //   bottom: "20%", //组件离容器下侧的距离,'20%' 
      //   orient: "vertical", //图例排列方向
      //   padding: [50, 10, 80, 60], //图例内边距，单位px  5  [5, 10]  [5,10,5,10]
      //   realtime: false,
      //   calculable: false,
      //   inRange: { //定义 在选中范围中 的视觉元素
      //     color: color
      //   },
      //   textStyle: { //字体颜色
      //     color: "#fff"
      //   },
      //   show: true
      // },
    },
    options: arrOptions
  };

  Trademap.setOption(option);
}
// Politics
export function initPoliticsmap(Politicsmap, Politicstitle, worlddata, nameMap) {
  Politicsmap.clear();
  var politicsjson = worlddata;
  var politicstimearray = [];
  var politicsseriesJson = [];
  //将politicsjson转成数组
  if (politicsjson != null && politicsjson.length > 0) {
    for (var i = 0; i < politicsjson.length; i++) { //年度
      var year = politicsjson[i].year;
      politicstimearray.push(year);
      let content = "";
      let arrContent = [];
      if (politicsjson != null && politicsjson.length > 0) { //每年数量
        for (var j = 0; j < politicsjson[i].data.length; j++) {
          var city = politicsjson[i].data[j].name;
          var value = politicsjson[i].data[j].value;
          var dpoliticsmin = politicsjson[i].min;
          var dpoliticsmax = politicsjson[i].max;
          content = {
            name: nameMap[city],
            value: value,
            year: year,
            dpoliticsmin: dpoliticsmin,
            dpoliticsmax: dpoliticsmax
          };
          arrContent.push(content);
        }
      }
      politicsseriesJson.push(arrContent);
    }
  }
  var politicsoptions = []; // 用来存储地图数据
  politicsseriesJson.forEach(function (item, i) {
    var itemarray = item;

    let newpoliticsmin = itemarray[0].dpoliticsmin;
    let newpoliticsmax = itemarray[0].dpoliticsmax;
    //只选一个国家时，图例的最大最小值相同，因此将最小改为0
    if (itemarray[0].dpoliticsmin == itemarray[0].dpoliticsmax) {
      newpoliticsmin = 0;
    }

    politicsoptions.push({
      visualMap: {
        min: newpoliticsmin,
        max: newpoliticsmax,
        // top: "60%",
        left: "left", //组件离容器左侧的距离,'left', 'center', 'right','20%'
        top: "45%", //组件离容器上侧的距离,'top', 'middle', 'bottom','20%'
        right: "20%", //组件离容器右侧的距离,'20%'
        bottom: "30%", //组件离容器下侧的距离,'20%'
        itemHeight: 100,
        text: ["High", "Low"],
        realtime: false,
        calculable: true,
        inRange: {
          color: ["#fcb61d", "#87cef9", "#1df9d2"]
        },
        textStyle: { //字体颜色
          color: "#fff"
        }
      },
      series: {
        data: itemarray
      }
    });
  });
  Politicsmap.setOption({
    timeline: {
      axisType: 'category',
      data: politicstimearray,
      autoPlay: true,
      playInterval: 5000,
      left: '2%',
      right: '2%',
      label: {
        normal: {
          textStyle: {
            color: '#fff' //年份字体颜色
          }
        },
        emphasis: {
          textStyle: {
            color: '#000'
          }
        }
      },
      lineStyle: {
        color: '#195ABE' //时间轴颜色
      },
      controlStyle: { //暂停”按钮
        normal: {
          color: '#fff',
          borderColor: '#fff'
        },
        emphasis: {
          color: '#fff',
          borderColor: '#fff'
        }
      },
    },
    baseOption: {
      tooltip: {
        trigger: "item",
        formatter: function (params) {
          if (params.componentSubType == "map") {
            if (params.value) {
              return params.name + "<br/>" + Politicstitle + "：" + params.value;
            } else {
              return params.name;
            }
          }
        }
      },
      series: [{
        type: 'map',
        map: 'world',
        roam: true,
        scaleLimit: { //滚轮缩放的极限控制
          min: 1,
          max: 2
        },
      }]
    },
    options: politicsoptions
  });
}
// Business
// export function initBusinessmap(Businessmap, worlddata, nameMap) {
//   Businessmap.clear();

//   var json = worlddata;
//   var timearray = [];
//   var seriesJson = [];

//   //将json转成数组
//   if (json != null && json.length > 0) {
//     for (var i = 0; i < json.length; i++) { //年度
//       var year = json[i].category;
//       timearray.push(year);
//       let content = "";
//       let arrContent = [];

//       if (json != null && json.length > 0) { //每年数量
//         for (var j = 0; j < json[i].data.length; j++) {
//           var city = json[i].data[j].name;
//           var value = json[i].data[j].value;
//           var year = json[i].category;
//           var dbusinessmin = json[i].min;
//           var dbusinessmax = json[i].max;
//           content = {
//             name: city,
//             value: value,
//             year: year,
//             dbusinessmin: dbusinessmin,
//             dbusinessmax: dbusinessmax
//           };
//           arrContent.push(content);
//         }
//       }
//       seriesJson.push(arrContent);
//     }
//   }

//   var series = []; // 用来存储地图数据

//   seriesJson.forEach(function (item, i) {
//     var itemarray = item;
//     let newdbusinessmin = itemarray[0].dbusinessmin;
//     let newdbusinessmax = itemarray[0].dbusinessmax;
//     //只选一个国家时，图例的最大最小值相同，因此将最小改为0
//     if (itemarray[0].dbusinessmin == itemarray[0].dbusinessmax) {
//       newdbusinessmin = 0;
//     }
//     series.push({
//       title: {
//         // text: '世界银行',
//         right: '10',
//         bottom: '40',
//         textStyle: {
//           color: '#fff',
//           fontSize: 14,
//           fontWeight: 'normal',
//         }
//       },
//       visualMap: {
//         min: newdbusinessmin,
//         max: newdbusinessmax,
//         // top: "60%",
//         left: "left", //组件离容器左侧的距离,'left', 'center', 'right','20%'
//         top: "45%", //组件离容器上侧的距离,'top', 'middle', 'bottom','20%'
//         right: "20%", //组件离容器右侧的距离,'20%'
//         bottom: "30%", //组件离容器下侧的距离,'20%'
//         itemHeight: 100,
//         text: ["High", "Low"],
//         realtime: false,
//         calculable: true,
//         inRange: {
//           color: ["#fcb61d", "#87cef9", "#1df9d2"]
//         },
//         textStyle: { //字体颜色
//           color: "#fff"
//         },
//       },
//       series: {
//         data: itemarray
//       }
//     });
//   });

//   Businessmap.setOption({
//     timeline: {
//       axisType: 'category',
//       data: timearray,
//       autoPlay: true,
//       playInterval: 5000,
//       left: '2%',
//       right: '2%',
//       label: {
//         normal: {
//           textStyle: {
//             color: '#fff' //年份字体颜色
//           }
//         },
//         emphasis: {
//           textStyle: {
//             color: '#000'
//           }
//         }
//       },
//       lineStyle: {
//         color: '#195ABE' //时间轴颜色
//       },
//       controlStyle: { //暂停”按钮
//         normal: {
//           color: '#fff',
//           borderColor: '#fff'
//         },
//         emphasis: {
//           color: '#fff',
//           borderColor: '#fff'
//         }
//       },
//     },
//     baseOption: {
//       tooltip: {
//         trigger: "item",
//         formatter: function (params) {
//           if (params.componentSubType == "map") {
//             if (params.value) {
//               return params.name + "<br/>总得分 : " + params.value;
//             } else {
//               return params.name;
//             }
//           }
//         }
//       },
//       series: [{
//         type: 'map',
//         map: 'world',
//         roam: true,
//         scaleLimit: { //滚轮缩放的极限控制
//           min: 1,
//           max: 2
//         },
//         nameMap: nameMap
//       }]
//     },
//     options: series
//   });
// }
export function initBusinessmap(Businessmap, worlddata, nameMap) {
  Businessmap.clear();

  var json = worlddata;
  var timearray = [];
  var seriesJson = [];

  // 将 json 转成数组
  if (json != null && json.length > 0) {
    for (var i = 0; i < json.length; i++) { // 年度
      var year = json[i].category;
      timearray.push(year);
      let content = "";
      let arrContent = [];

      if (json[i].data != null && json[i].data.length > 0) { // 每年数量
        // ========== 中国数据特殊处理 ==========
        var dataList = json[i].data;
        var mainlandItem = null;
        var hkItem = null;
        var twItem = null;

        for (var k = 0; k < dataList.length; k++) {
          var item = dataList[k];
          if (!item || !item.name) continue;

          var name = item.name;
          if (name === '中国' || name === '中国内地') {
            mainlandItem = item;
          } else if (name === '中国香港' || name === '中国香港特区') {
            hkItem = item;
          } else if (name === '台湾' || name === '中国台湾地区' || name === '中国台湾') {
            twItem = item;
          }
        }

        // 计算颜色映射用的最大值
        var values = [];
        if (mainlandItem && mainlandItem.value !== undefined && mainlandItem.value !== null) {
          values.push(mainlandItem.value);
        }
        if (hkItem && hkItem.value !== undefined && hkItem.value !== null) {
          values.push(hkItem.value);
        }
        if (twItem && twItem.value !== undefined && twItem.value !== null) {
          values.push(twItem.value);
        }

        var maxChinaValue = values.length > 0 ? Math.max.apply(null, values) : null;

        // 构建 tooltip 数据
        var chinaTooltipData = {
          mainland: (mainlandItem && mainlandItem.value !== undefined && mainlandItem.value !== null) ? mainlandItem.value : null,
          hongkong: (hkItem && hkItem.value !== undefined && hkItem.value !== null) ? hkItem.value : null,
          taiwan: (twItem && twItem.value !== undefined && twItem.value !== null) ? twItem.value : null,
          hasMainland: !!mainlandItem
        };

        var chinaProcessed = false;
        // =====================================

        for (var j = 0; j < json[i].data.length; j++) {
          var city = json[i].data[j].name;
          var value = json[i].data[j].value;
          var year = json[i].category;
          var dbusinessmin = json[i].min;
          var dbusinessmax = json[i].max;

          // 跳过香港和台湾（合并到中国）
          if (city === '中国香港' || city === '中国香港特区' ||
            city === '台湾' || city === '中国台湾地区' || city === '中国台湾') {
            continue;
          }

          // 中国：用最大值作为颜色，附加 tooltip 数据
          if (city === '中国' || city === '中国内地') {
            chinaProcessed = true;
            content = {
              name: city,
              value: maxChinaValue !== null ? maxChinaValue : value,
              year: year,
              dbusinessmin: dbusinessmin,
              dbusinessmax: dbusinessmax,
              _chinaData: chinaTooltipData
            };
          } else {
            // 其他国家：保持原样，携带 countryId 用于跳转
            var cid = json[i].data[j].CountryId !== undefined ? json[i].data[j].CountryId :
              (json[i].data[j].countryId !== undefined ? json[i].data[j].countryId :
                (json[i].data[j].id !== undefined ? json[i].data[j].id : null));
            content = {
              name: city,
              value: value,
              year: year,
              dbusinessmin: dbusinessmin,
              dbusinessmax: dbusinessmax,
              countryId: cid
            };
          }
          arrContent.push(content);
        }

        // 如果原始数据中没有中国，但有香港或台湾数据，手动添加
        if (!chinaProcessed && maxChinaValue !== null) {
          arrContent.push({
            name: '中国',
            value: maxChinaValue,
            year: year,
            dbusinessmin: dbusinessmin,
            dbusinessmax: dbusinessmax,
            _chinaData: chinaTooltipData
          });
        }
      }
      seriesJson.push(arrContent);
    }
  }

  var series = []; // 用来存储地图数据

  seriesJson.forEach(function (item, i) {
    var itemarray = item;
    let newdbusinessmin = itemarray[0].dbusinessmin;
    let newdbusinessmax = itemarray[0].dbusinessmax;
    // 只选一个国家时，图例的最大最小值相同，因此将最小改为 0
    if (itemarray[0].dbusinessmin == itemarray[0].dbusinessmax) {
      newdbusinessmin = 0;
    }
    series.push({
      title: {
        // text: '世界银行',
        right: '10',
        bottom: '40',
        textStyle: {
          color: '#fff',
          fontSize: 14,
          fontWeight: 'normal',
        }
      },
      visualMap: {
        min: newdbusinessmin,
        max: newdbusinessmax,
        // top: "60%",
        left: "left", // 组件离容器左侧的距离,'left', 'center', 'right','20%'
        top: "45%", // 组件离容器上侧的距离,'top', 'middle', 'bottom','20%'
        right: "20%", // 组件离容器右侧的距离,'20%'
        bottom: "30%", // 组件离容器下侧的距离,'20%'
        itemHeight: 100,
        text: ["High", "Low"],
        realtime: false,
        calculable: true,
        inRange: {
          color: ["#fcb61d", "#87cef9", "#1df9d2"]
        },
        textStyle: { // 字体颜色
          color: "#fff"
        },
      },
      series: {
        data: itemarray
      }
    });
  });

  Businessmap.setOption({
    timeline: {
      axisType: 'category',
      data: timearray,
      autoPlay: true,
      playInterval: 5000,
      left: '2%',
      right: '2%',
      label: {
        normal: {
          textStyle: {
            color: '#fff' // 年份字体颜色
          }
        },
        emphasis: {
          textStyle: {
            color: '#000'
          }
        }
      },
      lineStyle: {
        color: '#195ABE' // 时间轴颜色
      },
      controlStyle: { // 暂停"按钮
        normal: {
          color: '#fff',
          borderColor: '#fff'
        },
        emphasis: {
          color: '#fff',
          borderColor: '#fff'
        }
      },
    },
    baseOption: {
      tooltip: {
        trigger: "item",
        formatter: function (params) {
          if (params.componentSubType == "map") {
            // 中国特殊 tooltip
            if (params.data && params.data._chinaData) {
              var d = params.data._chinaData;
              var html = '<div style="font-weight:bold;margin-bottom:5px;">中国</div>';

              if (d.hasMainland && d.mainland !== null) {
                html += '中国内地支柱一 : ' + (Math.round(d.mainland * 100) / 100) + '<br/>';
              } else {
                html += '中国内地支柱一得分 : 暂无数据<br/>';
              }

              if (d.hongkong !== null) {
                html += '中国香港特区支柱一得分 : ' + (Math.round(d.hongkong * 100) / 100) + '<br/>';
              } else {
                html += '中国香港特区支柱一得分 : 暂无数据<br/>';
              }

              if (d.taiwan !== null) {
                html += '中国台湾地区支柱一得分 : ' + (Math.round(d.taiwan * 100) / 100);
              } else {
                html += '中国台湾地区支柱一得分 : 暂无数据';
              }

              return html;
            }

            // 其他国家
            if (params.value !== undefined && params.value !== null && params.value !== '' && !isNaN(params.value)) {
              return params.name + "<br/>支柱一得分 : " + (Math.round(params.value * 100) / 100);
            }

            // 没有数据：只显示国家名
            return params.name;
          }
        }
      },
      series: [{
        type: 'map',
        map: 'world',
        roam: true,
        scaleLimit: { // 滚轮缩放的极限控制
          min: 1,
          max: 2
        },
        nameMap: nameMap
      }]
    },
    options: series
  });

  // ========== 点击跳转事件 ==========
  // 安全地移除旧事件
  try {
    Businessmap.off('click');
  } catch (e) {
    // 如果 off 方法不存在或出错，忽略
  }

  Businessmap.on('click', function (params) {
    // 调试日志（开发时可打开）
    // console.log('地图点击:', params.name, 'data:', params.data, 'value:', params.value);

    // 中国不跳转
    if (params.data && params.data._chinaData) {
      return;
    }

    // 没有数据的国家不跳转
    if (params.value === undefined || params.value === null || params.value === '') {
      return;
    }

    // 有数据的国家跳转
    if (params.data && params.data.countryId !== undefined && params.data.countryId !== null) {
      var url = window.location.origin + window.location.search + '#/db/economy?countryid=' + params.data.countryId;
      // 尝试新标签页打开
      var newWindow = window.open(url, '_blank');
      // 如果被拦截，使用当前页跳转
      if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
        window.location.href = url;
      }
    }
  });
}
// Yuanqu
export function initYuanqumap(Yuanqumap, worlddata, geoCoordMapdata) {
  geoCoordMap = geoCoordMapdata;
  Yuanqumap.clear();
  var json = worlddata;

  var convertData = function (data) {
    var res = [];
    for (var i = 0; i < data.length; i++) {
      let cityCoord = geoCoordMap[data[i].name];
      if (cityCoord != undefined)
        res.push({
          name: data[i].name,
          value: [cityCoord[0], cityCoord[1], data[i].value],
        });
    }
    return res;
  };

  var option = {
    title: {
      // text: '鼠标移动到圆点上显示园区列表',
      right: '0',
      bottom: '20',
      textStyle: {
        color: '#fff',
        fontSize: 14,
        fontWeight: 'normal',
      },
    },
    tooltip: {
      padding: 0,
      enterable: true,
      transitionDuration: 1,
      position: function (pos, params, dom, rect, size) {
        return [pos[0], pos[1]];
      },
      // background: 'rgba(7,39,104,.6)',  
      textStyle: {
        color: '#fff',
      },
      formatter: function (params) {
        if (params.data != undefined) {
          for (var i = 0; i < json.length; i++) {
            if (params.name === json[i].name) {
              var tipHtml = '<ul style="overflow: auto;';
              if (json[i].data.length == 0) { //暂无数据时
                tipHtml += '">';
                tipHtml += '<li style="text-align:left;padding:5px 5px 5px 5px;">暂无数据</li></ul>';
              } else {
                if (json[i].data.length >= 10) {
                  tipHtml += "height:315px";
                }
                tipHtml += '">';
                for (var j = 0; j < json[i].data.length; j++) {
                  tipHtml += '<li style="text-align:left;padding:5px 5px 5px 5px;"><a target="_blank" style="cursor:pointer; color:#fff;" href="/#/lit/channel2?uid=8012&subuid=801202&attr=' + json[i].data[j].name + '">' +
                    json[i].data[j].name + '</a></li>';
                }
                tipHtml += '</ul>';
              }
              return tipHtml;
            }
          }
        }
        //以下else不行，无法移到没数据的国家上显示
        // else {
        //   var tipHtml = '<div>暂无数据</div>';
        //   return tipHtml;
        // }
      }
    },
    series: [{
      type: 'scatter', //'effectScatter', 
      coordinateSystem: 'geo',
      data: convertData(json),
      label: {
        normal: {
          formatter: '{b}',
          position: 'right',
          show: true
        },
        emphasis: {
          show: true
        }
      },
      itemStyle: {
        normal: {
          color: '#ffde12'
        }
      }
    },
    {
      type: 'map',
      map: "world",
      // nameMap: nameMap,
      geoIndex: 0,
      aspectScale: 0.75, //长宽比
      showLegendSymbol: false, // 存在legend时显示
      label: {
        normal: {
          show: true
        },
        emphasis: {
          show: false,
          textStyle: {
            color: '#fff'
          }
        }
      },
      roam: true,
      // scaleLimit: { //滚轮缩放的极限控制
      //   min: 1,
      //   // max: 2
      // },
      itemStyle: {
        normal: {
          areaColor: '#031525',
          borderColor: '#3B5077',

        },
        emphasis: {
          areaColor: '#2B91B7'
        }
      },
      animation: false
    },
    ],
    geo: {
      show: true,
      map: "world",
      label: {
        normal: {
          show: false
        },
        emphasis: {
          show: false,
        }
      },
      roam: true,
      scaleLimit: { //滚轮缩放的极限控制
        min: 1,
        max: 2
      },
      itemStyle: {
        normal: {
          areaColor: '#17468f',
          borderColor: '#04184b'
        },
        emphasis: {
          areaColor: '#17468f' //鼠标移到某国家上颜色
        }
      },
    },
  };
  Yuanqumap.setOption(option);
}
